<app-step-dialog-shell
  [controller]="this"
  mode="tabs"
  [title]="title"
  [subtitle]="subtitle"
  [showClose]="true"
  primaryLabel="Save Benefits"
  [disablePrimary]="isSaving || isLoadingBonuses || isLoadingReimbursed || isLoadingBenefitsProducts || isLoadingPayrollDeductionCodes || !!loadError"
  (closeClicked)="close()"
  (cancelClicked)="close()"
  (primaryClicked)="save()"
  >
  <ng-template [stepDialogStep]="'health'">
    <ng-container
      [ngTemplateOutlet]="benefitsCategoryTemplate"
      [ngTemplateOutletContext]="{ category: 'health' }"
    ></ng-container>
  </ng-template>

  <ng-template [stepDialogStep]="'supplemental'">
    <ng-container
      [ngTemplateOutlet]="benefitsCategoryTemplate"
      [ngTemplateOutletContext]="{ category: 'supplemental' }"
    ></ng-container>
  </ng-template>

  <ng-template [stepDialogStep]="'retirement'">
    <ng-container
      [ngTemplateOutlet]="benefitsCategoryTemplate"
      [ngTemplateOutletContext]="{ category: 'retirement' }"
    ></ng-container>
  </ng-template>

  <ng-template [stepDialogStep]="'pnc'">
    <ng-container
      [ngTemplateOutlet]="benefitsCategoryTemplate"
      [ngTemplateOutletContext]="{ category: 'pnc' }"
    ></ng-container>
  </ng-template>

  <ng-template [stepDialogStep]="'other'">
    <ng-container
      [ngTemplateOutlet]="benefitsCategoryTemplate"
      [ngTemplateOutletContext]="{ category: 'other' }"
    ></ng-container>
  </ng-template>

  <ng-template #benefitsCategoryTemplate let-category="category">
    @if (category === 'health' && canShowSourceTeamProductHelper) {
      <section class="source-team-helper">
        <button
          type="button"
          class="source-team-helper-header"
          [attr.aria-expanded]="isSourceTeamProductHelperExpanded"
          (click)="isSourceTeamProductHelperExpanded = !isSourceTeamProductHelperExpanded"
          >
          <span class="source-team-helper-title">Select products from existing team</span>
          <span class="source-team-helper-action">{{ isSourceTeamProductHelperExpanded ? 'Hide' : 'Show' }}</span>
        </button>
        @if (isSourceTeamProductHelperExpanded) {
          <p class="source-team-helper-description">
            Preview another team's product choices, then apply them to this draft. Nothing changes until you save benefits. This does not link the teams; the source team is not saved.
          </p>
          <div class="source-team-helper-controls">
            <mat-form-field appearance="outline">
              <mat-label>Team product source</mat-label>
              <mat-select
                [(ngModel)]="selectedSourceTeamId"
                placeholder="Choose a team"
                (selectionChange)="onSourceTeamSelectionChanged()"
                [disabled]="isSourceTeamOptionsLoading || isSourceTeamProductPreviewLoading || sourceTeamOptions.length === 0"
                >
                @for (sourceTeam of sourceTeamOptions; track sourceTeam) {
                  <mat-option [value]="sourceTeam.id">
                    {{ sourceTeam.label }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <button
              mat-stroked-button
              type="button"
              color="primary"
              [disabled]="!selectedSourceTeamId || isSourceTeamOptionsLoading || isSourceTeamProductPreviewLoading"
              (click)="loadSourceTeamProductPreview()"
              >
              Preview Team Products
            </button>
            @if (isSourceTeamOptionsLoading || isSourceTeamProductPreviewLoading) {
              <mat-spinner [diameter]="24"></mat-spinner>
            }
          </div>
          @if (!isSourceTeamOptionsLoading && !sourceTeamOptionsError && sourceTeamOptions.length === 0) {
            <p class="source-team-helper-message">
              No other teams are available as a product source.
            </p>
          }
          @if (sourceTeamOptionsError) {
            <p class="source-team-helper-message warning">{{ sourceTeamOptionsError }}</p>
          }
          @if (sourceTeamProductPreviewError) {
            <p class="source-team-helper-message warning">{{ sourceTeamProductPreviewError }}</p>
          }
          @if (sourceTeamProductPreviewProductIds.length || sourceTeamProductPreviewSkippedProductIds.length || sourceTeamProductPreviewHiddenProductIds.length) {
            <div class="source-team-preview">
              <p class="source-team-summary">
                {{ sourceTeamProductPreviewProductIds.length }} source products can be applied.
                {{ sourceTeamProductPreviewAddedProductIds.length }} would be added,
                {{ sourceTeamProductPreviewOverlappingProductIds.length }} are already selected, and
                {{ sourceTeamProductPreviewRemovedProductIds.length }} would be removed.
                {{ sourceTeamProductPreviewAllowanceEligibleProductIds.length }} copied products allow payment with Wallit allowance.
              </p>
              <div class="source-team-diff">
                <div>
                  <h4>Would Add</h4>
                  @if (sourceTeamProductPreviewAddedProductIds.length === 0) {
                    <p>No products</p>
                  }
                  @if (sourceTeamProductPreviewAddedProductIds.length) {
                    <ul>@for (productId of sourceTeamProductPreviewAddedProductIds; track productId) {
                      <li>{{ getSourceTeamProductDisplay(productId) }}</li>
                    }</ul>
                  }
                </div>
                <div>
                  <h4>Already Selected</h4>
                  @if (sourceTeamProductPreviewOverlappingProductIds.length === 0) {
                    <p>No products</p>
                  }
                  @if (sourceTeamProductPreviewOverlappingProductIds.length) {
                    <ul>@for (productId of sourceTeamProductPreviewOverlappingProductIds; track productId) {
                      <li>{{ getSourceTeamProductDisplay(productId) }}</li>
                    }</ul>
                  }
                </div>
                <div>
                  <h4>Would Remove</h4>
                  @if (sourceTeamProductPreviewRemovedProductIds.length === 0) {
                    <p>No products</p>
                  }
                  @if (sourceTeamProductPreviewRemovedProductIds.length) {
                    <ul>@for (productId of sourceTeamProductPreviewRemovedProductIds; track productId) {
                      <li>{{ getSourceTeamProductDisplay(productId) }}</li>
                    }</ul>
                  }
                </div>
                @if (sourceTeamProductPreviewSkippedProductIds.length) {
                  <div>
                    <h4>Cannot apply</h4>
                    <ul>@for (productId of sourceTeamProductPreviewSkippedProductIds; track productId) {
                      <li>{{ getSourceTeamProductDisplay(productId) }}</li>
                    }</ul>
                  </div>
                }
                @if (sourceTeamProductPreviewHiddenProductIds.length) {
                  <div>
                    <h4>Not editable in this workspace</h4>
                    <p>These products will be left unchanged.</p>
                    <ul>@for (productId of sourceTeamProductPreviewHiddenProductIds; track productId) {
                      <li>{{ productId }}</li>
                    }</ul>
                  </div>
                }
              </div>
              <button mat-raised-button type="button" color="accent" [disabled]="!canApplySourceTeamProductPreview()" (click)="applySourceTeamProductPreview()">
                Apply To Selection
              </button>
              @if (sourceTeamProductPreviewApplied) {
                <p class="source-team-applied">Products were applied to the current draft. Use Save Benefits to persist.</p>
              }
            </div>
          }
        }
      </section>
    }
    <div class="benefits-card">
      @if (!isLoadingBenefitsProducts) {
        @for (section of getBenefitSections(category); track trackBenefitSection($index, section)) {
          <div class="benefits-section">
            <h3 class="benefits-section-title">{{ section.title }}</h3>
            @if (section.products.length > 0) {
              @for (product of section.products; track trackBenefitProduct($index, product)) {
                <div class="benefit-product-card">
                  <div
                    class="benefit-product-card-header"
                    [class.benefit-product-card-header--pending]="isBenefitProductPending(product)"
                    [class.benefit-product-card-header--requestable]="isBenefitProductRequestable(product)"
                    (click)="onBenefitProductClicked(product)"
                    >
                    <mat-checkbox
                      class="benefit-product-checkbox"
                      [checked]="isBenefitProductSelected(product.id)"
                      [disabled]="!canInteractWithBenefitProductCheckbox(product)"
                      (click)="$event.stopPropagation()"
                      (change)="onBenefitProductCheckboxChanged(product, $event.checked)"
                      >
                    </mat-checkbox>
                    <div class="benefit-product-logo-wrap">
                      @if (product.imageUrl) {
                        <img
                          class="benefit-product-logo"
                          [src]="product.imageUrl"
                          [alt]="(product.vendorName || product.productName || 'Benefit') + ' logo'"
                          loading="eager"
                          decoding="async"
                          referrerpolicy="no-referrer"
                          (error)="product.imageUrl = ''"
                          />
                      }
                      @if (!product.imageUrl) {
                        <div class="benefit-product-logo-placeholder">
                          {{ (product.vendorName || product.productName || '?').charAt(0) }}
                        </div>
                      }
                    </div>
                    <div class="benefit-product-main">
                      <div class="benefit-product-name">{{ product.vendorName || product.productName }}</div>
                      <div class="benefit-product-description">
                        {{ product.description || product.productName }}
                      </div>
                      @if (product.alwaysActive) {
                        <div class="benefit-product-status status-available">
                          Always available for all teams
                        </div>
                      }
                      @if (getBenefitProductStatusLabel(product)) {
                        <div class="benefit-product-status" [ngClass]="getBenefitProductStatusClass(product)">
                          {{ getBenefitProductStatusLabel(product) }}
                        </div>
                      }
                      @if (product.approvalDisabledReason) {
                        <div class="benefit-product-status-reason">
                          {{ product.approvalDisabledReason }}
                        </div>
                      }
                    </div>
                    @if (product.detailsUrl) {
                      <div class="benefit-product-actions">
                        <button
                          mat-stroked-button
                          type="button"
                          class="benefit-product-details-btn"
                          (click)="openBenefitProductDetails(product, $event)"
                          >
                          View details
                        </button>
                      </div>
                    }
                  </div>
                  @if (canShowAllowanceControl(product)) {
                    <div class="allowance-control-panel">
                      <mat-checkbox
                        [checked]="product.allowanceEligible === true"
                        [disabled]="isSaving"
                        (change)="onAllowanceEligibilityToggle(product, $event.checked)"
                        >
                        Allow Wallit allowance
                      </mat-checkbox>
                      <div class="allowance-control-helper">
                        Let employees pay for this product using their Wallit allowance balance.
                      </div>
                    </div>
                  }
                </div>
              }
            } @else {
              <app-coming-soon-upsell
                class="benefits-empty-upsell"
                [featureKey]="'payroll-benefits-' + category + '-' + section.id"
                title=""
                description="We are actively working to expand the benefits available to you and your employees. If you'd like us to prioritize adding options in this category, give us a thumbs up and tell us a little about what you want."
                [renderMode]="'expanded'"
                [allowFeedback]="true"
                [context]="{ source: 'edit-benefits-dialog', category: category, sectionId: section.id }"
                >
              </app-coming-soon-upsell>
            }
          </div>
        }
      } @else {
        <div class="benefits-loading">Loading products...</div>
      }

    </div>
  </ng-template>

  <ng-template [stepDialogStep]="'reimbursed'">
    <div class="reimbursed-card">
      @if (loadError) {
        <div role="alert">{{ loadError }} <button mat-button (click)="retryLoading()">Retry</button></div>
      }
      @if (saveError) {
        <p role="alert">{{ saveError }}</p>
      }
      @if (!isLoadingReimbursed) {
        @if (data.teamManager) {
          <section class="reimbursed-section">
            <h3 class="reimbursed-title">Monthly Allowance</h3>
            <mat-form-field appearance="outline">
              <mat-label>Amount per member / month</mat-label>
              <span matTextPrefix>$&nbsp;</span>
              <input matInput type="number" min="0" max="1000" step="0.01"
                [(ngModel)]="selectedAllowance" [disabled]="isSaving || !!loadError">
            </mat-form-field>
          </section>
        }
        <section class="reimbursement-setting">
          <mat-slide-toggle
            [(ngModel)]="reimbursementsEnabled"
            [disabled]="isSaving || !!loadError"
            aria-describedby="reimbursement-setting-description"
          >Allow reimbursements</mat-slide-toggle>
          <p id="reimbursement-setting-description">
            {{ reimbursementsEnabled
            ? 'Team members can request and approve reimbursements for eligible purchases.'
            : 'Team members cannot request or approve reimbursements. Saved category settings are kept for when you enable reimbursements again.' }}
            Changes take effect when you save.
          </p>
        </section>
        @if (reimbursementsEnabled) {
          @if (data.teamManager) {
            <section class="reimbursed-section">
              <h3 class="reimbursed-title">Reimbursement Categories</h3>
              <p>Select the transaction categories covered by the monthly allowance.</p>
              <div class="custom-reimbursement-field-label">Taxable</div>
              <div class="reimbursed-categories">
                @for (category of taxableReimbursedCategories; track category) {
                  <button type="button"
                    class="reimbursed-chip" [class.selected]="category.selected" [attr.aria-pressed]="category.selected"
                    [matTooltip]="category.toolTip" [disabled]="isSaving || !!loadError"
                  (click)="onReimbursedCategoryClicked(category)">{{ category.category }}</button>
                }
              </div>
              <div class="custom-reimbursement-field-label">Non-Taxable</div>
              <div class="reimbursed-categories">
                @for (category of nonTaxableReimbursedCategories; track category) {
                  <button type="button"
                    class="reimbursed-chip" [class.selected]="category.selected" [attr.aria-pressed]="category.selected"
                    [matTooltip]="category.toolTip" [disabled]="isSaving || !!loadError"
                  (click)="onReimbursedCategoryClicked(category)">{{ category.category }}</button>
                }
              </div>
            </section>
          }
          <div class="reimbursed-section preset-reimbursed-section">
            <h3 class="reimbursed-title">Preset Reimbursement Limits</h3>
            <div class="preset-reimbursement-list">
              @for (presetState of presetReimbursementCategories; track trackPresetReimbursementCategory($index, presetState)) {
                <div
                  class="preset-reimbursement-card"
                  [class.enabled]="presetState.enabled"
                  >
                  <div class="preset-reimbursement-card-header">
                    <mat-checkbox
                      class="preset-reimbursement-toggle"
                      [checked]="presetState.enabled"
                      [disabled]="isSaving"
                      (change)="onPresetReimbursementCategoryToggle(presetState.preset.key, $event.checked)"
                      >
                    </mat-checkbox>
                    <div class="preset-reimbursement-card-copy">
                      <div class="preset-reimbursement-card-title">{{ presetState.preset.label }}</div>
                      <div class="preset-reimbursement-card-subtitle">
                        Set a monthly reimbursement limit for these categories.
                      </div>
                    </div>
                  </div>
                  <div class="custom-reimbursement-item-tags preset-reimbursement-tags">
                    @for (spendCategory of presetState.preset.spendCategories; track spendCategory) {
                      <span class="custom-reimbursement-item-tag">
                        {{ spendCategory }}
                      </span>
                    }
                  </div>
                  @if (presetState.enabled) {
                    <div class="custom-reimbursement-amount-row">
                      <span class="custom-reimbursement-amount-currency">$</span>
                      <input
                        class="custom-reimbursement-amount-input"
                        type="number"
                        min="0"
                        step="0.01"
                        [value]="(presetState.category?.maxAmountCents || 0) / 100"
                        [disabled]="isSaving"
                        (input)="onPresetReimbursementCategoryAmountInput(presetState.preset.key, $event)"
                        />
                      <div class="custom-reimbursement-rollover-copy">
                        <mat-checkbox
                          class="custom-reimbursement-rollover"
                          [checked]="!!presetState.category?.rollover"
                          [disabled]="isSaving"
                          (change)="onPresetReimbursementCategoryRolloverToggle(presetState.preset.key, $event.checked)"
                          >
                          Allow unused funds to roll over each month
                        </mat-checkbox>
                        <div class="custom-reimbursement-rollover-description">
                          If Rollover is selected, any unused funds would be added to the next month's allowance balance.
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          <div class="reimbursed-section custom-reimbursed-section">
            <h3 class="reimbursed-title">Custom Reimbursement Categories</h3>
            @if (activeCustomReimbursementCategories.length) {
              <div class="custom-reimbursement-list">
                @for (customCategory of activeCustomReimbursementCategories; track trackCustomReimbursementCategory($index, customCategory)) {
                  <div
                    class="custom-reimbursement-item"
                    >
                    <div class="custom-reimbursement-item-header">
                      <div class="custom-reimbursement-item-name">{{ customCategory.name }}</div>
                      <div class="custom-reimbursement-item-actions">
                        <button
                          type="button"
                          class="custom-reimbursement-link-btn"
                          [disabled]="isSaving"
                          (click)="editCustomReimbursementCategory(customCategory)"
                          >
                          Edit
                        </button>
                        <button
                          type="button"
                          class="custom-reimbursement-link-btn danger"
                          [disabled]="isSaving"
                          (click)="archiveCustomReimbursementCategory(customCategory)"
                          >
                          Delete
                        </button>
                      </div>
                    </div>
                    <div class="custom-reimbursement-item-meta">
                      Monthly max:
                      <strong>${{ customCategory.maxAmountCents / 100 | number:'1.0-2' }}</strong>
                      <span class="custom-reimbursement-dot">•</span>
                      Unused balance:
                      <strong>{{ customCategory.rollover ? 'Rolls over at month boundary' : 'Resets at month boundary' }}</strong>
                    </div>
                    <div class="custom-reimbursement-item-tags">
                      @for (spendCategory of customCategory.spendCategories; track spendCategory) {
                        <span class="custom-reimbursement-item-tag">
                          {{ spendCategory }}
                        </span>
                      }
                      @if (!data.teamManager) {
                        @for (productId of customCategory.vendorProductIds; track productId) {
                          <span class="custom-reimbursement-item-tag product">
                            {{ getAssignableReimbursementProductLabel(productId) }}
                          </span>
                        }
                      }
                      @if (data.teamManager && customCategory.vendorProductIds.length) {
                        <span class="custom-reimbursement-item-tag">
                          Existing product coverage retained
                        </span>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            @if (!isCustomReimbursementEditorVisible) {
              <button
                type="button"
                class="custom-reimbursement-add-btn"
                [disabled]="isSaving"
                (click)="startCustomReimbursementCategory()"
                >
                + Add Custom Reimbursement Category
              </button>
            }
            @if (isCustomReimbursementEditorVisible) {
              <div class="custom-reimbursement-editor">
                <div class="custom-reimbursement-editor-title">
                  {{ editingCustomReimbursementCategoryKey ? 'Edit Custom Reimbursement' : 'New Custom Reimbursement' }}
                </div>
                <div class="custom-reimbursement-editor-subtitle">
                  Custom reimbursement categories use a monthly budget. Set the monthly max here, and choose whether
                  unused funds roll over into the next month's allowance balance.
                </div>
                <div class="custom-reimbursement-field-label">Category Name</div>
                <input
                  class="custom-reimbursement-name-input"
                  type="text"
                  [value]="customReimbursementDraft.name"
                  [disabled]="isSaving"
                  placeholder="e.g. Remote Work Supplies"
                  (input)="onCustomReimbursementDraftNameInput($event)"
                  />
                <div class="custom-reimbursement-field-label">Spend Categories (Taxable)</div>
                <div class="reimbursed-categories">
                  @for (category of taxableReimbursedCategories; track category) {
                    <button
                      type="button"
                      class="reimbursed-chip"
                      [class.selected]="isCustomReimbursementDraftSpendCategorySelected(category.category)"
                      [disabled]="isSaving"
                      (click)="onCustomReimbursementDraftSpendCategoryClicked(category.category)"
                      >
                      {{ category.category }}
                    </button>
                  }
                </div>
                <div class="custom-reimbursement-field-label">Spend Categories (Non-Taxable)</div>
                <div class="reimbursed-categories">
                  @for (category of nonTaxableReimbursedCategories; track category) {
                    <button
                      type="button"
                      class="reimbursed-chip"
                      [class.selected]="isCustomReimbursementDraftSpendCategorySelected(category.category)"
                      [disabled]="isSaving"
                      (click)="onCustomReimbursementDraftSpendCategoryClicked(category.category)"
                      >
                      {{ category.category }}
                    </button>
                  }
                </div>
                <div class="custom-reimbursement-field-label">Monthly Max Amount</div>
                <div class="custom-reimbursement-amount-row">
                  <span class="custom-reimbursement-amount-currency">$</span>
                  <input
                    class="custom-reimbursement-amount-input"
                    type="number"
                    min="0"
                    step="0.01"
                    [value]="customReimbursementDraft.maxAmountDollars"
                    [disabled]="isSaving"
                    (input)="onCustomReimbursementDraftAmountInput($event)"
                    />
                  <div class="custom-reimbursement-rollover-copy">
                    <mat-checkbox
                      class="custom-reimbursement-rollover"
                      [checked]="customReimbursementDraft.rollover"
                      [disabled]="isSaving"
                      (change)="onCustomReimbursementDraftRolloverToggle($event.checked)"
                      >
                      Allow unused funds to roll over each month
                    </mat-checkbox>
                    <div class="custom-reimbursement-rollover-description">
                      If Rollover is selected, any unused funds would be added to the next month's allowance balance.
                    </div>
                  </div>
                </div>
                <div class="custom-reimbursement-action-row">
                  <button
                    type="button"
                    class="custom-reimbursement-action-btn"
                    [disabled]="isSaving"
                    (click)="saveCustomReimbursementCategory()"
                    >
                    {{ editingCustomReimbursementCategoryKey ? 'Save Reimbursement Category' : 'Add Reimbursement Category' }}
                  </button>
                  <button
                    type="button"
                    class="custom-reimbursement-link-btn"
                    [disabled]="isSaving"
                    (click)="cancelCustomReimbursementEdit()"
                    >
                    Cancel
                  </button>
                </div>
              </div>
            }
          </div>
          <div class="reimbursed-section excluded-transactions-section">
            <h3 class="reimbursed-title">Excluded transactions</h3>
            <div class="excluded-transactions-helper">
              Transactions whose description contains one of these phrases will not be reimbursed for this team.
            </div>
            <mat-form-field appearance="outline" class="excluded-transactions-field">
              <mat-label>Excluded transactions</mat-label>
              <mat-chip-grid #excludedTransactionChipGrid aria-label="Excluded transactions">
                @for (term of excludedTransactionTerms; track trackExcludedTransactionTerm($index, term)) {
                  <mat-chip-row
                    [removable]="!isSaving"
                    (removed)="removeExcludedTransactionTerm(term)"
                    >
                    {{ term }}
                    <button matChipRemove type="button" [disabled]="isSaving" [attr.aria-label]="'Remove ' + term">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip-row>
                }
                <input
                  placeholder="amazon prime"
                  [disabled]="isSaving"
                  [matChipInputFor]="excludedTransactionChipGrid"
                  [matChipInputSeparatorKeyCodes]="excludedTransactionSeparatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addExcludedTransactionTerm($event)"
                  matInput
                  />
              </mat-chip-grid>
            </mat-form-field>
            @if (broadExcludedTransactionTerms.length) {
              <div class="excluded-transactions-warning">
                <mat-icon>warning_amber</mat-icon>
                <span>
                  Broad exclusions such as {{ broadExcludedTransactionTerms.join(', ') }} can hide unrelated eligible transactions.
                </span>
              </div>
            }
            <h3 class="reimbursed-title">Included transactions</h3>
            <div class="excluded-transactions-helper">
              Transactions whose description contains one of these phrases will be considered reimbursable for this team.
            </div>
            <mat-form-field appearance="outline" class="excluded-transactions-field">
              <mat-label>Included transactions</mat-label>
              <mat-chip-grid #includedTransactionChipGrid aria-label="Included transactions">
                @for (term of includedTransactionTerms; track trackIncludedTransactionTerm($index, term)) {
                  <mat-chip-row
                    [removable]="!isSaving"
                    (removed)="removeIncludedTransactionTerm(term)"
                    >
                    {{ term }}
                    <button matChipRemove type="button" [disabled]="isSaving" [attr.aria-label]="'Remove ' + term">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip-row>
                }
                <input
                  placeholder="uber"
                  [disabled]="isSaving"
                  [matChipInputFor]="includedTransactionChipGrid"
                  [matChipInputSeparatorKeyCodes]="includedTransactionSeparatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addIncludedTransactionTerm($event)"
                  matInput
                  />
              </mat-chip-grid>
            </mat-form-field>
          </div>
        }
      } @else {
        <div class="reimbursed-loading">Loading reimbursement categories...</div>
      }

    </div>
  </ng-template>

  <ng-template [stepDialogStep]="'bonuses'">
    <div class="bonuses-card">
      @if (loadError) {
        <div role="alert">{{ loadError }} <button mat-button (click)="retryLoading()">Retry</button></div>
      }
      @if (saveError) {
        <p role="alert">{{ saveError }}</p>
      }
      @for (bonus of bonusSettings; track bonus) {
        <div class="bonus-item">
          <mat-checkbox
            class="bonus-toggle"
            [checked]="bonus.enabled"
            [disabled]="isLoadingBonuses || isSaving"
            (change)="onBonusToggle($event.checked, bonus)"
            [aria-label]="bonus.name"
            >
          </mat-checkbox>
          <div class="bonus-content">
            <h3 class="bonus-title">{{ bonus.name }}</h3>
            <p class="bonus-description">{{ bonus.description }}</p>
            <div class="bonus-amount-row">
              <span class="bonus-amount-label">Amount:</span>
              <span class="bonus-amount-currency">$</span>
              <input
                class="bonus-amount-input"
                type="number"
                min="0"
                step="0.01"
                [value]="bonus.amount"
                [disabled]="!bonus.enabled || isLoadingBonuses || isSaving"
                (input)="onAmountInput(bonus, $event)"
                />
            </div>
          </div>
        </div>
      }
    </div>
  </ng-template>
</app-step-dialog-shell>
